var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('nav',{staticClass:"navbar navbar-expand-lg navbar-light main-color sp-header"},[_c('div',{staticClass:"col col-sm-6"},[_c('a',{staticClass:"mr-4 text-light h2",attrs:{"href":"#"}},[_vm._v(_vm._s(this.config.projectName))]),_vm._v(" "),_c('span',{staticClass:"text-light sp-header-text"},[_vm._v("納品完了・画像登録")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dff0bbe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeliveryImageSpHeader.vue
// module id = null
// module chunks = 